import { render, staticRenderFns } from "./ContactEditAppBar.vue?vue&type=template&id=37a19085&"
import script from "./ContactEditAppBar.vue?vue&type=script&lang=ts&"
export * from "./ContactEditAppBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports